import { useQuery, useMutation, useQueryClient } from 'react-query';
import { producerAPI } from '../../services/api';
import toast from 'react-hot-toast';

export const useProducer = () => {
  const queryClient = useQueryClient();

  const { data: profile, isLoading, error } = useQuery(
    'producer-profile',
    async () => {
      try {
        const response = await producerAPI.getProfile();
        return response.data.data;
      } catch (error) {
        // If producer not found (404), return null instead of throwing
        if (error.status === 404) {
          return null;
        }
        // For other errors, throw so they can be handled
        throw error;
      }
    },
    {
      retry: false,
    }
  );

  const registerMutation = useMutation(
    (data) => producerAPI.register(data),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries('producer-profile');
        toast.success('Farm registered successfully!');
        return response;
      },
      onError: (error) => {
        console.error('Producer registration error:', error);
        // Log validation details if available
        if (error.details) {
          console.error('Validation errors:', error.details);
        }
        toast.error(error.message || 'Failed to register farm');
      },
    }
  );

  const updateMutation = useMutation(
    (data) => producerAPI.updateProfile(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('producer-profile');
        toast.success('Profile updated successfully!');
      },
      onError: (error) => {
        toast.error(error.message || 'Failed to update profile');
      },
    }
  );

  return {
    profile,
    isLoading,
    error,
    register: registerMutation.mutate,
    update: updateMutation.mutate,
    isRegistering: registerMutation.isLoading,
    isUpdating: updateMutation.isLoading,
  };
};
